import { CheckCircle2, AlertCircle } from "lucide-react";

export const LeadFeedback = ({ feedback, form }) => {
  if (!feedback) return null;
  const success = feedback.type === "success";
  const Icon = success ? CheckCircle2 : AlertCircle;
  return (
    <p
      role={success ? "status" : "alert"}
      data-testid={`${form}-${success ? "success" : "error"}`}
      className={`flex items-start gap-2 rounded-lg border p-4 text-sm leading-relaxed ${
        success ? "border-mint/30 bg-mint/5 text-mintlight" : "border-red-400/30 bg-red-400/5 text-red-200"
      }`}
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{feedback.message}</span>
    </p>
  );
};